import React from "react";

const OrderSuccess = () => {
  const orderID = localStorage.getItem("orderID");

  return (
    <div>
      <h2>🎉 Order Successful!</h2>
      <p>Your Order ID: {orderID}</p>
      <p>Thank you for shopping with Neev Organic Haat Store.</p>
    </div>
  );
};

export default OrderSuccess;
